import { IFormValidatorState, RESET_FORM_VALIDATOR, SUCCESS_FORM_VALIDATOR } from '../types'

const initialState: IFormValidatorState = {
  errorForm: [],
  errorTab: [],
  msgForm: [],
  msgTab: [],
  isValidForm: false
}

export default function (state = initialState, action: any) {
  switch (action.type) {
    case RESET_FORM_VALIDATOR:
      return {
        ...state,
        errorForm: [],
        errorTab: [],
        msgForm: [],
        msgTab: [],
        isValidForm: false
      }
    case SUCCESS_FORM_VALIDATOR:
      return {
        ...state,
        errorTab: action.payload.errorTab,
        errorForm: action.payload.errorForm,
        msgForm: action.payload.msgForm,
        msgTab: action.payload.msgTab,
        isValidForm: action.payload.isValidForm
      }
    default:
      return state
  }
}
